import moment from 'moment';
import { storeToRefs } from 'pinia';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

export const useRetention = () => {
  const organizationStore = useOrganizationStore();
  const viewerItemStore = useViewerItemStore();

  const isItemsRetentionEnabled = () => {
    const { itemsRemoveEnabledAt } = storeToRefs(organizationStore);
    const { createdAt } = storeToRefs(viewerItemStore);
    if (!itemsRemoveEnabledAt.value) {
      return false;
    }

    // Check if the item was created after the retention was enabled
    const isAfter = moment(createdAt.value).isAfter(itemsRemoveEnabledAt.value);
    return isAfter;
  };

  return { isItemsRetentionEnabled };
};
